// Iconsax-style sidebar icons.
//
// Format follows the CoreUI `@coreui/icons` convention so that <CIcon name="cil-…"/>
// keeps resolving the same names — we just substitute the SVG content.
// Each export is `[ '<width> <height>', '<inner-svg-content>' ]`. CoreUI's CIcon
// (CIconRaw inside @coreui/vue — NOT a file in this repo) uses element [0] as the
// viewBox size, i.e. viewBox="0 0 <width> <height>", and element [1] as the SVG
// body. So most icons here use '24 24', but any icon may declare its own viewBox —
// e.g. the brand logos at the bottom use '640 640' / '192 192'. (There is no
// hardcoded 24x24; an earlier version of this comment claimed one — it was wrong.)
//
// Visual contract: 24x24 grid, fill="none", stroke="currentColor", stroke-width="1.5",
// round caps/joins. Shared attrs live on a wrapper <g>.

const open = '<g fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
const close = '</g>'
const wrap = (body) => `${open}${body}${close}`

export const cilSpeedometer = ['24 24', wrap(
  '<path d="M3.2 14.5a8.8 8.8 0 1 1 17.6 0"/>' +
  '<path d="M12 14.5l4.6-3.1"/>' +
  '<circle cx="12" cy="14.5" r="1.4" fill="currentColor" stroke="none"/>'
)]

export const cilEnvelopeClosed = ['24 24', wrap(
  '<path d="M17 20.5H7c-3 0-5-1.5-5-5v-7c0-3.5 2-5 5-5h10c3 0 5 1.5 5 5v7c0 3.5-2 5-5 5z"/>' +
  '<path d="M17 9l-3.13 2.5c-1.03.82-2.72.82-3.75 0L7 9"/>'
)]

export const cilChartPie = ['24 24', wrap(
  '<path d="M21.5 12.5a9.5 9.5 0 1 1-9.5-9.5"/>' +
  '<path d="M21.5 10.5a8 8 0 0 0-8-8v8h8z"/>'
)]

export const cilLocationPin = ['24 24', wrap(
  '<circle cx="12" cy="10.5" r="2.75"/>' +
  '<path d="M3.62 8.99C5.59.34 18.42.63 20.38 8.99c1.15 4.92-1.91 9.08-4.59 11.66-1.95 1.88-5.04 1.88-7.01 0-2.67-2.58-5.73-6.75-4.16-11.66z"/>'
)]

export const cilGrid = ['24 24', wrap(
  '<path d="M10.5 8.5V4c0-1.4-.64-2-2.23-2H4.23C2.64 2 2 2.6 2 4v4.5c0 1.4.64 2 2.23 2h4.04c1.59 0 2.23-.6 2.23-2z"/>' +
  '<path d="M22 8.5V4c0-1.4-.64-2-2.23-2h-4.04c-1.59 0-2.23.6-2.23 2v4.5c0 1.4.64 2 2.23 2h4.04c1.59 0 2.23-.6 2.23-2z"/>' +
  '<path d="M10.5 20v-4.5c0-1.4-.64-2-2.23-2H4.23c-1.59 0-2.23.6-2.23 2V20c0 1.4.64 2 2.23 2h4.04c1.59 0 2.23-.6 2.23-2z"/>' +
  '<path d="M22 20v-4.5c0-1.4-.64-2-2.23-2h-4.04c-1.59 0-2.23.6-2.23 2V20c0 1.4.64 2 2.23 2h4.04c1.59 0 2.23-.6 2.23-2z"/>'
)]

export const cilPhone = ['24 24', wrap(
  '<path d="M21.97 18.33a2.54 2.54 0 0 1-.25 1.09 4.27 4.27 0 0 1-.67 1.01c-.51.56-1.07.97-1.7 1.22-.62.26-1.3.39-2.03.39-1.06 0-2.2-.25-3.4-.76a18.4 18.4 0 0 1-3.59-2.07 30.3 30.3 0 0 1-3.42-2.93 30 30 0 0 1-2.93-3.41A18.7 18.7 0 0 1 1.93 9.3c-.5-1.2-.75-2.35-.75-3.44 0-.72.12-1.4.37-2.04.25-.65.65-1.25 1.22-1.77.69-.67 1.45-1 2.24-1 .3 0 .6.07.87.2.28.13.52.32.71.61l2.45 3.45c.19.27.33.51.42.74.09.22.14.45.14.65 0 .26-.07.51-.22.76-.14.25-.34.51-.6.77l-.8.83c-.12.12-.17.26-.17.42 0 .08.01.16.03.24.03.08.05.14.07.2.19.35.51.81 1 1.36.5.55 1.03 1.11 1.6 1.67.59.59 1.17 1.13 1.74 1.62.55.49 1.01.82 1.36 1.02.05.02.11.04.18.07.08.03.16.04.25.04.18 0 .32-.06.43-.17l.79-.79c.27-.27.53-.48.78-.61.25-.15.5-.23.77-.23.21 0 .42.04.65.13.23.09.47.22.74.4l3.49 2.47c.27.19.46.41.58.66.11.27.16.51.16.79z"/>'
)]

export const cilPencil = ['24 24', wrap(
  '<path d="M11.4 2H8.3C4.7 2 3 3.7 3 7.3v9.4C3 20.3 4.7 22 8.3 22h9.4c3.6 0 5.3-1.7 5.3-5.3v-3.1"/>' +
  '<path d="M16.04 3.02L8.16 10.9c-.3.3-.6.89-.66 1.32l-.43 3.01c-.16 1.09.61 1.85 1.7 1.7l3.01-.43c.43-.06 1.02-.36 1.32-.66l7.88-7.88c1.36-1.36 2-2.94 0-4.94-2-2-3.58-1.36-4.94 0z"/>' +
  '<path d="M14.91 4.15a7.14 7.14 0 0 0 4.94 4.94"/>'
)]

export const cilCalculator = ['24 24', wrap(
  '<path d="M16.5 22h-9C4 22 2 20 2 16.5v-9C2 4 4 2 7.5 2h9C20 2 22 4 22 7.5v9c0 3.5-2 5.5-5.5 5.5z"/>' +
  '<path d="M7 6.5h10v3.5H7z"/>' +
  '<path d="M7.5 14.25h.01"/>' +
  '<path d="M12 14.25h.01"/>' +
  '<path d="M16.5 14.25h.01"/>' +
  '<path d="M7.5 17.75h.01"/>' +
  '<path d="M12 17.75h.01"/>' +
  '<path d="M16.5 17.75h.01"/>'
)]

export const cilList = ['24 24', wrap(
  '<path d="M8 6.5h12"/>' +
  '<path d="M8 12h12"/>' +
  '<path d="M8 17.5h12"/>' +
  '<circle cx="4" cy="6.5" r="1.1" fill="currentColor" stroke="none"/>' +
  '<circle cx="4" cy="12" r="1.1" fill="currentColor" stroke="none"/>' +
  '<circle cx="4" cy="17.5" r="1.1" fill="currentColor" stroke="none"/>'
)]

export const cilLayers = ['24 24', wrap(
  '<path d="M13.06 2.43l8.05 3.58c1.18.52 1.18 2.06 0 2.58l-8.05 3.58a3.16 3.16 0 0 1-2.12 0L2.89 8.59c-1.18-.52-1.18-2.06 0-2.58l8.05-3.58c.67-.3 1.45-.3 2.12 0z"/>' +
  '<path d="M2 11.5c0 .78.59 1.68 1.31 2l8.65 3.76c1.05.46 2.18.46 3.22 0l8.65-3.76c.72-.32 1.31-1.22 1.31-2"/>' +
  '<path d="M2 16.5c0 .86.51 1.64 1.31 1.99l8.65 3.76c1.05.46 2.18.46 3.22 0l8.65-3.76c.8-.35 1.31-1.13 1.31-1.99"/>'
)]

export const cilBasket = ['24 24', wrap(
  '<path d="M3 9h18l-1.4 11.18c-.16 1.27-1.24 2.32-2.51 2.32H6.91a2.55 2.55 0 0 1-2.51-2.31L3 9z"/>' +
  '<path d="M8 9V6.5a4 4 0 0 1 8 0V9"/>' +
  '<path d="M9 13.5h6"/>'
)]

export const cilUser = ['24 24', wrap(
  '<circle cx="12" cy="7.75" r="4.25"/>' +
  '<path d="M4 20.5c.99-3.05 4.32-5.25 8-5.25s7.01 2.2 8 5.25"/>'
)]

export const cilTask = ['24 24', wrap(
  '<path d="M16.5 22h-9C4 22 2 20 2 16.5v-9C2 4 4 2 7.5 2h9C20 2 22 4 22 7.5v9c0 3.5-2 5.5-5.5 5.5z"/>' +
  '<path d="M7.75 12l1.81 1.81L14.25 9"/>'
)]

export const cilStar = ['24 24', wrap(
  '<path d="M13.73 3.51l1.79 3.58c.24.5.89.97 1.44 1.07l3.24.54c2.07.34 2.56 1.85 1.07 3.34l-2.53 2.53c-.43.43-.66 1.26-.53 1.85l.72 3.13c.57 2.47-.74 3.42-2.92 2.14l-3.04-1.81c-.55-.32-1.45-.32-2 0l-3.04 1.81c-2.17 1.28-3.49.33-2.92-2.14l.72-3.13c.13-.59-.1-1.42-.53-1.85L2.67 12.05c-1.48-1.49-1-3 1.07-3.34l3.24-.54c.54-.09 1.19-.57 1.44-1.07l1.79-3.58c.97-2.04 2.55-2.04 3.52 0z"/>'
)]

export const cilCloudUpload = ['24 24', wrap(
  '<path d="M16.34 8.32A6 6 0 0 0 6 11c-2.21 0-4 1.79-4 4s1.79 4 4 4h12c2.76 0 5-2.24 5-5 0-2.65-2.07-4.81-4.66-4.98z"/>' +
  '<path d="M12 19v-7"/>' +
  '<path d="M9 14.5l3-3 3 3"/>'
)]

export const cilCloudDownload = ['24 24', wrap(
  '<path d="M16.34 8.32A6 6 0 0 0 6 11c-2.21 0-4 1.79-4 4s1.79 4 4 4h12c2.76 0 5-2.24 5-5 0-2.65-2.07-4.81-4.66-4.98z"/>' +
  '<path d="M12 12v7"/>' +
  '<path d="M9 16.5l3 3 3-3"/>'
)]

export const cilCash = ['24 24', wrap(
  '<path d="M17 19.5H7c-3.5 0-5-1.5-5-5v-7c0-3.5 1.5-5 5-5h10c3.5 0 5 1.5 5 5v7c0 3.5-1.5 5-5 5z"/>' +
  '<circle cx="12" cy="11" r="2.5"/>' +
  '<path d="M5.75 8.5v5"/>' +
  '<path d="M18.25 8.5v5"/>'
)]

export const cilWallet = ['24 24', wrap(
  '<path d="M2.5 9.75c0-3.5 2-5.25 5-5.25h9c3 0 5 1.75 5 5.25v4.5c0 3.5-2 5.25-5 5.25h-9c-3 0-5-1.75-5-5.25v-4.5z"/>' +
  '<path d="M21.5 12.5h-3.25a2 2 0 0 0 0 4h3.25"/>' +
  '<path d="M7 8h6"/>'
)]

export const cilDollar = ['24 24', wrap(
  '<circle cx="12" cy="12" r="10"/>' +
  '<path d="M9 14.75c0 1.1.85 2 1.9 2h2.14c.92 0 1.66-.77 1.66-1.74 0-1.05-.46-1.41-1.14-1.66l-3.42-1.18c-.69-.24-1.14-.62-1.14-1.66 0-.95.75-1.74 1.66-1.74h2.14c1.05 0 1.9.89 1.9 2"/>' +
  '<path d="M12 7.5v9"/>'
)]

export const cilFile = ['24 24', wrap(
  '<path d="M22 10v5c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7h4"/>' +
  '<path d="M22 10h-4c-3 0-4-1-4-4V2l8 8z"/>' +
  '<path d="M7 13h6"/>' +
  '<path d="M7 17h4"/>'
)]

export const cilCheckCircle = ['24 24', wrap(
  '<circle cx="12" cy="12" r="10"/>' +
  '<path d="M7.75 12l2.83 2.83 5.67-5.66"/>'
)]

export const cilLibrary = ['24 24', wrap(
  '<path d="M22 16.5V4.74c0-1.17-.95-2.04-2.11-1.94h-.06c-2.05.18-5.17 1.23-6.91 2.32l-.16.1c-.28.18-.75.18-1.04 0l-.24-.14C9.74 4 6.62 2.97 4.57 2.8c-1.16-.1-2.11.78-2.11 1.94V16.5c0 .94.76 1.81 1.7 1.94l.27.03c2.12.28 5.39 1.36 7.27 2.39l.04.02c.27.15.7.15.97 0 1.88-1.04 5.16-2.12 7.29-2.41l.27-.03c.94-.13 1.7-1 1.7-1.94z"/>' +
  '<path d="M12 5.49v14.5"/>'
)]

export const cilCommentSquare = ['24 24', wrap(
  '<path d="M8 18.5h-.5c-4 0-6-1-6-6V6.5c0-4 2-6 6-6h8c4 0 6 2 6 6V12.5c0 4-2 6-6 6h-.5c-.31 0-.61.15-.8.4l-1.5 2c-.66.88-1.74.88-2.4 0l-1.5-2c-.16-.22-.53-.4-.8-.4z"/>' +
  '<path d="M7 7.5h10"/>' +
  '<path d="M7 11.5h7"/>'
)]

export const cilSettings = ['24 24', wrap(
  '<circle cx="12" cy="12" r="3"/>' +
  '<path d="M2 12.88v-1.76c0-1.04.85-1.9 1.9-1.9 1.81 0 2.55-1.28 1.64-2.85-.52-.9-.21-2.07.7-2.59l1.73-.99c.79-.47 1.81-.19 2.28.6l.11.19c.9 1.57 2.38 1.57 3.29 0l.11-.19c.47-.79 1.49-1.07 2.28-.6l1.73.99c.91.52 1.22 1.69.7 2.59-.91 1.57-.17 2.85 1.64 2.85 1.04 0 1.9.85 1.9 1.9v1.76c0 1.04-.85 1.9-1.9 1.9-1.81 0-2.55 1.28-1.64 2.85.52.91.21 2.07-.7 2.59l-1.73.99c-.79.47-1.81.19-2.28-.6l-.11-.19c-.9-1.57-2.38-1.57-3.29 0l-.11.19c-.47.79-1.49 1.07-2.28.6l-1.73-.99c-.91-.52-1.22-1.69-.7-2.59.91-1.57.17-2.85-1.64-2.85-1.05 0-1.9-.86-1.9-1.9z"/>'
)]

export const cilPeople = ['24 24', wrap(
  '<circle cx="9" cy="7.5" r="4"/>' +
  '<path d="M16 8.5a3.5 3.5 0 1 0 0-7"/>' +
  '<path d="M2 18.5c0-2.485 3.134-4.5 7-4.5s7 2.015 7 4.5"/>' +
  '<path d="M16.5 14c2.55.27 4.5 1.46 4.5 3.5 0 1.34-.7 2.27-2 3"/>'
)]

export const cilUserFollow = ['24 24', wrap(
  '<circle cx="9" cy="7.5" r="4"/>' +
  '<path d="M2 20c0-3.87 3.13-7 7-7s7 3.13 7 7"/>' +
  '<path d="M19 8v6"/>' +
  '<path d="M22 11h-6"/>'
)]

export const cilLockLocked = ['24 24', wrap(
  '<path d="M6 10V8a6 6 0 0 1 12 0v2"/>' +
  '<path d="M17 22H7c-4 0-5-1-5-5v-2c0-4 1-5 5-5h10c4 0 5 1 5 5v2c0 4-1 5-5 5z"/>' +
  '<path d="M12 16v-3"/>'
)]

export const cilCalendar = ['24 24', wrap(
  '<path d="M8 2v3"/>' +
  '<path d="M16 2v3"/>' +
  '<path d="M3.5 9.09h17"/>' +
  '<path d="M21 8.5V17c0 3-1.5 5-5 5H8c-3.5 0-5-2-5-5V8.5c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5z"/>' +
  '<path d="M8 13h.01"/>' +
  '<path d="M12 13h.01"/>' +
  '<path d="M16 13h.01"/>' +
  '<path d="M8 17h.01"/>' +
  '<path d="M12 17h.01"/>'
)]

export const cilArrowRight = ['24 24', wrap(
  '<path d="M3.5 12h17"/>' +
  '<path d="M14.4 5.93L20.5 12l-6.1 6.07"/>'
)]

export const cilSpeech = ['24 24', wrap(
  '<path d="M17 18.43h-4l-4.45 2.96c-.66.44-1.55-.03-1.55-.83v-2.13c-3 0-5-2-5-5v-6c0-3 2-5 5-5h10c3 0 5 2 5 5v6c0 3-2 5-5 5z"/>' +
  '<path d="M7.5 10.5h9"/>' +
  '<path d="M7.5 14h6"/>'
)]

export const cilBarcode = ['24 24', wrap(
  '<path d="M3 5v14"/>' +
  '<path d="M6.5 5v14"/>' +
  '<path d="M10 5v10"/>' +
  '<path d="M13.5 5v14"/>' +
  '<path d="M17.5 5v10"/>' +
  '<path d="M21 5v14"/>'
)]

export const cilScan = ['24 24', wrap(
  '<path d="M2 9V7c0-2.76 2.24-5 5-5h2"/>' +
  '<path d="M15 2h2c2.76 0 5 2.24 5 5v2"/>' +
  '<path d="M22 16v1c0 2.76-2.24 5-5 5h-2"/>' +
  '<path d="M9 22H7c-2.76 0-5-2.24-5-5v-2"/>' +
  '<path d="M2 12h20"/>'
)]

export const cilTruck = ['24 24', wrap(
  '<path d="M3 6.5C3 5.4 3.9 4.5 5 4.5h7.5c1.1 0 2 .9 2 2v9.5c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V6.5z"/>' +
  '<path d="M14.5 8.5h4.4c.4 0 .77.18 1.02.48l2.05 2.46c.21.26.33.58.33.92V16c0 .55-.45 1-1 1h-1.8"/>' +
  '<circle cx="7" cy="18.5" r="2"/>' +
  '<circle cx="17" cy="18.5" r="2"/>' +
  '<path d="M9 18.5h6"/>'
)]

export const cilReceipt = ['24 24', wrap(
  '<path d="M7 2h10a2 2 0 0 1 2 2v16.5L17 22l-2-1.5L13 22l-2-1.5L9 22l-2-1.5L5 22V4a2 2 0 0 1 2-2z"/>' +
  '<path d="M8 7.5h8"/>' +
  '<path d="M8 11.5h8"/>' +
  '<path d="M8 15.5h5"/>'
)]

export const cilTicket = ['24 24', wrap(
  '<path d="M4 6.5h16a2 2 0 0 1 2 2v1.25a.75.75 0 0 1-.55.72 2.5 2.5 0 0 0 0 4.81.75.75 0 0 1 .55.72v1.25a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1.25a.75.75 0 0 1 .55-.72 2.5 2.5 0 0 0 0-4.81.75.75 0 0 1-.55-.72V8.5a2 2 0 0 1 2-2z"/>' +
  '<path d="M9.5 6.5v11"/>'
)]

export const cilCallIncoming = ['24 24', wrap(
  '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.9.36 1.78.7 2.62a2 2 0 0 1-.45 2.11L8.09 9.81a16 16 0 0 0 6 6l1.36-1.36a2 2 0 0 1 2.11-.45c.84.34 1.72.57 2.62.7A2 2 0 0 1 22 16.92z"/>' +
  '<path d="M21 3l-5 5"/>' +
  '<path d="M21 8h-5V3"/>'
)]

export const cilCup = ['24 24', wrap(
  '<path d="M7.5 3.5h9v6.5c0 2.49-2.01 4.5-4.5 4.5S7.5 12.49 7.5 10V3.5z"/>' +
  '<path d="M16.5 5h2c1.1 0 2 .9 2 2v.5c0 1.66-1.34 3-3 3h-1"/>' +
  '<path d="M7.5 5h-2c-1.1 0-2 .9-2 2v.5c0 1.66 1.34 3 3 3h1"/>' +
  '<path d="M9 20.5h6"/>' +
  '<path d="M12 14.5v6"/>'
)]

export const cilBox = ['24 24', wrap(
  '<path d="M21 8.66v6.68c0 .72-.39 1.39-1.02 1.74l-7 3.85c-.6.33-1.32.33-1.92 0l-7-3.85A1.99 1.99 0 0 1 3 15.34V8.66c0-.72.39-1.39 1.02-1.74l7-3.85c.6-.33 1.32-.33 1.92 0l7 3.85c.63.35 1.06 1.02 1.06 1.74z"/>' +
  '<path d="M3 8l9 5 9-5"/>' +
  '<path d="M12 22v-9"/>'
)]

export const cilRefund = ['24 24', wrap(
  '<path d="M4 11h11a5 5 0 0 1 5 5v1a5 5 0 0 1-5 5H8"/>' +
  '<path d="M7 7.5L3 11l4 3.5"/>'
)]

export const cilNote = ['24 24', wrap(
  '<path d="M16 2H8C4 2 2 4 2 8v8c0 4 2 6 6 6h8c4 0 6-2 6-6V8c0-4-2-6-6-6z"/>' +
  '<path d="M7.5 8.5h9"/>' +
  '<path d="M7.5 12h9"/>' +
  '<path d="M7.5 15.5h5"/>'
)]

export const cilChartUp = ['24 24', wrap(
  '<path d="M2.5 21.5h19"/>' +
  '<path d="M4.5 17.5l5-6 4 4 6-8"/>' +
  '<path d="M15 7.5h4.5V12"/>'
)]

export const cilCallOutgoing = ['24 24', wrap(
  '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.9.36 1.78.7 2.62a2 2 0 0 1-.45 2.11L8.09 9.81a16 16 0 0 0 6 6l1.36-1.36a2 2 0 0 1 2.11-.45c.84.34 1.72.57 2.62.7A2 2 0 0 1 22 16.92z"/>' +
  '<path d="M16 8l5-5"/>' +
  '<path d="M21 8V3h-5"/>'
)]

export const cilChartBar = ['24 24', wrap(
  '<path d="M2 21h20"/>' +
  '<path d="M5 21v-7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7"/>' +
  '<path d="M10 21V8a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v13"/>' +
  '<path d="M15 21v-10a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v10"/>'
)]

// ── De-duplication pass: unique, label-relevant sidebar icons ──────────────
// Added so every distinct sidebar link gets its own meaningful glyph (see the
// role *Sidebar.js files). Same 24x24 / 1.5-stroke outline contract as above.

export const cilRoute = ['24 24', wrap(
  '<path d="M9 2.5 3 5v16.5l6-2.5 6 2.5 6-2.5V4.5l-6 2.5-6-2.5z"/>' +
  '<path d="M9 2.5V19"/>' +
  '<path d="M15 5v16.5"/>'
)]

export const cilCart = ['24 24', wrap(
  '<circle cx="9" cy="20" r="1.4"/>' +
  '<circle cx="17.5" cy="20" r="1.4"/>' +
  '<path d="M2.5 3h2.2l2.1 12.2a1.5 1.5 0 0 0 1.48 1.25h8.4a1.5 1.5 0 0 0 1.47-1.2L20.5 7H6"/>'
)]

export const cilBuilding = ['24 24', wrap(
  '<path d="M4 21V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v16"/>' +
  '<path d="M15 9h3a2 2 0 0 1 2 2v10"/>' +
  '<path d="M2 21h20"/>' +
  '<path d="M8 7h3M8 11h3M8 15h3"/>'
)]

export const cilDevices = ['24 24', wrap(
  '<rect x="2.5" y="4" width="13" height="9" rx="1.5"/>' +
  '<path d="M5.5 17h6"/>' +
  '<path d="M9 13v4"/>' +
  '<rect x="16.5" y="9" width="5.5" height="11" rx="1.2"/>'
)]

export const cilFlag = ['24 24', wrap(
  '<path d="M5 21V3.5"/>' +
  '<path d="M5 4h12.5l-2.5 4 2.5 4H5"/>'
)]

export const cilCreditCard = ['24 24', wrap(
  '<rect x="2.5" y="5" width="19" height="14" rx="2"/>' +
  '<path d="M2.5 9.5h19"/>' +
  '<path d="M6 15h4"/>'
)]

export const cilGift = ['24 24', wrap(
  '<rect x="3.5" y="8.5" width="17" height="4" rx="1"/>' +
  '<path d="M5 12.5V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7.5"/>' +
  '<path d="M12 8.5V21"/>' +
  '<path d="M12 8.5S10.6 4 8.3 4a2.25 2.25 0 0 0 0 4.5H12z"/>' +
  '<path d="M12 8.5S13.4 4 15.7 4a2.25 2.25 0 0 1 0 4.5H12z"/>'
)]

export const cilHandCoin = ['24 24', wrap(
  '<circle cx="16" cy="6.5" r="3.5"/>' +
  '<path d="M2.5 13l3-1a3 3 0 0 1 2 .05l3 1.15a2 2 0 0 0 1.5 0l4.2-1.6a1.6 1.6 0 0 1 1.7 2.6l-4.9 4a4 4 0 0 1-4 .75L5.5 17.5"/>' +
  '<path d="M2.5 12v7.5"/>'
)]

export const cilShareArrow = ['24 24', wrap(
  '<path d="M4 14v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"/>' +
  '<path d="M12 15V3"/>' +
  '<path d="M8 7l4-4 4 4"/>'
)]

export const cilSpreadsheet = ['24 24', wrap(
  '<rect x="3.5" y="3.5" width="17" height="17" rx="2"/>' +
  '<path d="M3.5 9h17M3.5 15h17M9 3.5v17M15 3.5v17"/>'
)]

export const cilReport = ['24 24', wrap(
  '<path d="M6 2.5h8l4 4V21a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1z"/>' +
  '<path d="M14 2.5V6.5h4"/>' +
  '<path d="M8.5 17v-2M12 17v-4M15.5 17v-6"/>'
)]

export const cilChartLine = ['24 24', wrap(
  '<path d="M4 4v15a1 1 0 0 0 1 1h15"/>' +
  '<path d="M7 15l3.5-4 3 2.5L20 7"/>'
)]

export const cilUserChart = ['24 24', wrap(
  '<circle cx="8" cy="7" r="3"/>' +
  '<path d="M2.5 20a5.5 5.5 0 0 1 11 0"/>' +
  '<path d="M17 20v-5M20.5 20v-9"/>'
)]

export const cilPhoneChart = ['24 24', wrap(
  '<path d="M4.5 4.6c0-1 .82-1.78 1.8-1.68l2.2.22c.68.07 1.26.57 1.45 1.25l.66 2.35a1.6 1.6 0 0 1-.48 1.68l-1.28 1a11 11 0 0 0 4.55 4.55l1-1.28a1.6 1.6 0 0 1 1.68-.48l2.35.66c.68.19 1.18.77 1.25 1.45l.22 2.2c.1.98-.68 1.8-1.68 1.8A14.8 14.8 0 0 1 4.5 4.6z"/>' +
  '<path d="M15.5 8.5 20 4"/>' +
  '<path d="M20 4h-3M20 4v3"/>'
)]

export const cilMoneyBack = ['24 24', wrap(
  '<path d="M20.5 12a8.5 8.5 0 1 1-2.45-5.95"/>' +
  '<path d="M20.5 2.5V7h-4.5"/>' +
  '<path d="M12 8.5v7"/>' +
  '<path d="M10 11h2.6a1.6 1.6 0 0 1 0 3.2H10l2.7 2"/>'
)]

export const cilPackage = ['24 24', wrap(
  '<path d="M3.5 8.5 12 4l8.5 4.5v7L12 20l-8.5-4.5v-7z"/>' +
  '<path d="M3.5 8.5 12 13l8.5-4.5"/>' +
  '<path d="M12 13v7"/>' +
  '<path d="M7.75 6.25 16.25 10.75"/>'
)]

export const cilFunnel = ['24 24', wrap(
  '<path d="M3.5 5h17l-6.5 8v6l-4 2v-8L3.5 5z"/>'
)]

export const cilInventory = ['24 24', wrap(
  '<rect x="8.5" y="3.5" width="7" height="7" rx="1"/>' +
  '<rect x="3" y="13.5" width="7" height="7" rx="1"/>' +
  '<rect x="14" y="13.5" width="7" height="7" rx="1"/>'
)]

export const cilCopy = ['24 24', wrap(
  '<rect x="8" y="8" width="12" height="12" rx="2"/>' +
  '<path d="M16 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3"/>'
)]

// Dangling imports that were masked by the sidebar's cil-list fallback until the
// ALLOWED_ICONS whitelist was widened — icons.js imported these two names but
// iconsax.js never defined them, so <CIcon> rendered blank. Now drawn.

export const cilClock = ['24 24', wrap(
  '<circle cx="12" cy="12" r="9"/>' +
  '<path d="M12 7.5V12l3.2 2"/>'
)]

export const cilFingerprint = ['24 24', wrap(
  '<path d="M4.7 8.3a8 8 0 0 1 14.5-.1"/>' +
  '<path d="M8 10.8a4 4 0 0 1 8 0v1.7a10 10 0 0 0 .9 4.1"/>' +
  '<path d="M12 10.8v2.2a13 13 0 0 0 1.3 5.6"/>' +
  '<path d="M8.1 13a13 13 0 0 0 1.7 6.2"/>' +
  '<path d="M5.4 15.2a12 12 0 0 0 .7 2.7"/>'
)]

// Dashboard tile product glyphs, grouped by metric "subject":
//  - OBJECT families (bottles, farm bottles) draw the object; the "…Return" variant
//    adds a curved back-arrow and the plural variant doubles it for bulk.
//  - UNIT families (money → cilRupee, weight → "KG" text) use the unit symbol; their
//    return variant is a circular refund arrow with the symbol inside.

// Milk/water bottle: capped neck flaring into a rounded body.
export const cilBottle = ['24 24', wrap(
  '<path d="M10.5 2.5h3v3.5c0 .55.2 1.05.6 1.45l1.35 1.35c.68.68 1.05 1.6 1.05 2.55V19c0 1.5-1 2.5-2.5 2.5h-4C8.5 21.5 7.5 20.5 7.5 19v-7.65c0-.95.37-1.87 1.05-2.55L9.9 7.4c.4-.4.6-.9.6-1.45V2.5z"/>' +
  '<path d="M10 5h4"/>'
)]

// Two bottles — the "bulk bottles" marker (a pair vs the single-unit bottle).
export const cilBottles = ['24 24', wrap(
  '<path d="M5.5 3h3v2.4c0 .55.22 1.08.6 1.46l.95.95c.5.5.78 1.2.78 1.92V17.5c0 1.25-.85 2.1-2.1 2.1H5.3c-1.25 0-2.1-.85-2.1-2.1V9.73c0-.72.28-1.42.78-1.92l.95-.95c.38-.38.6-.9.6-1.46V3z"/>' +
  '<path d="M5.1 5.2h3.8"/>' +
  '<path d="M15 5h3v2.4c0 .55.22 1.08.6 1.46l.95.95c.5.5.78 1.2.78 1.92V19.5c0 1.25-.85 2.1-2.1 2.1h-3.66c-1.25 0-2.1-.85-2.1-2.1v-7.77c0-.72.28-1.42.78-1.92l.95-.95c.38-.38.6-.9.6-1.46V5z"/>' +
  '<path d="M14.6 7.2h3.8"/>'
)]

// Bottle with a curved return arrow — for "bottles returned" tiles.
export const cilBottleReturn = ['24 24', wrap(
  '<path d="M6.8 2.5h2.9v2.7c0 .55.22 1.08.6 1.46l1.05 1.05c.52.52.82 1.24.82 1.98V19c0 1.3-.9 2.2-2.2 2.2H5.8C4.5 21.2 3.6 20.3 3.6 19V9.49c0-.74.3-1.46.82-1.98l1.05-1.05c.38-.38.6-.9.6-1.46V2.5z"/>' +
  '<path d="M6.4 4.7h3.3"/>' +
  '<path d="M21 17a5.6 5.6 0 0 0-5.6-5.6H12"/>' +
  '<path d="M15 7.8l-3 3.6 3 3.2"/>'
)]

// Farm-bottle family: a BOTTLE marked with a small leaf (= "farm bottle"), so the
// icon matches the "Farm Bottles" label instead of a bare leaf. Return adds a
// back-arrow; bulk doubles the bottle. (These replaced the plain-leaf glyphs.)
export const cilBottleLeaf = ['24 24', wrap(
  '<path d="M9 3.5h2.6v3c0 .5.18.95.52 1.28l1.16 1.16c.6.6.92 1.4.92 2.24V19c0 1.35-.9 2.25-2.25 2.25H7.55C6.2 21.25 5.3 20.35 5.3 19v-7.82c0-.84.32-1.64.92-2.24l1.16-1.16c.34-.33.52-.78.52-1.28V3.5z"/>' +
  '<path d="M8.6 5.7h3"/>' +
  '<path d="M15.8 8.2c0-3.3 2.3-5.6 5.6-5.6 0 3.3-2.3 5.6-5.6 5.6z"/>' +
  '<path d="M15.8 8.2c1.1-1.5 2.5-2.9 4.4-4"/>'
)]

// Farm bottle with a curved return arrow — "farm bottles returned".
export const cilBottleLeafReturn = ['24 24', wrap(
  '<path d="M8 3h2.4v2.7c0 .5.18.95.52 1.28l1 1c.5.5.78 1.2.78 1.92V18c0 1.2-.8 2-2 2H6.7C5.5 20 4.7 19.2 4.7 18V9.9c0-.72.28-1.42.78-1.92l1-1c.34-.33.52-.78.52-1.28V3z"/>' +
  '<path d="M7.6 5h2.9"/>' +
  '<path d="M13.5 7.5c0-2.6 1.8-4.4 4.4-4.4 0 2.6-1.8 4.4-4.4 4.4z"/>' +
  '<path d="M21 18.5a4.8 4.8 0 0 0-4.8-4.8H13"/>' +
  '<path d="M15.5 10.5l-2.5 3 2.5 2.6"/>'
)]

// Two farm bottles — the "bulk farm bottles" marker.
export const cilBottlesLeaf = ['24 24', wrap(
  '<path d="M5.5 4.5h2.6v2.1c0 .5.2.95.53 1.28l.83.83c.44.44.69 1.05.69 1.68V17c0 1.1-.75 1.85-1.85 1.85H5.15C4.05 18.85 3.3 18.1 3.3 17v-6.6c0-.63.25-1.24.69-1.68l.83-.83c.33-.33.53-.78.53-1.28V4.5z"/>' +
  '<path d="M13.5 6h2.6v2.1c0 .5.2.95.53 1.28l.83.83c.44.44.69 1.05.69 1.68V18.5c0 1.1-.75 1.85-1.85 1.85h-3.26C11.75 20.35 11 19.6 11 18.5v-6.6c0-.63.25-1.24.69-1.68l.83-.83c.33-.33.53-.78.53-1.28V6z"/>' +
  '<path d="M17.2 6.2c0-2.5 1.8-4.3 4.3-4.3 0 2.5-1.8 4.3-4.3 4.3z"/>'
)]

// Infinity (lemniscate) — used for the "total conversion rate" tile.
export const cilInfinity = ['24 24', wrap(
  '<path d="M9.83 9.17a4 4 0 1 0 0 5.66 10 10 0 0 0 2.17-2.83 10 10 0 0 1 2.17-2.83 4 4 0 1 1 0 5.66 10 10 0 0 1-2.17-2.83 10 10 0 0 0-2.17-2.83z"/>'
)]

// Indian Rupee sign — for money tiles (sales amount).
export const cilRupee = ['24 24', wrap(
  '<path d="M19.8 2.9h-14.3h3.9a5.2 5.2 0 0 1 0 10.4h-3.9l7.8 7.8"/>' +
  '<path d="M5.5 8.1h14.3"/>'
)]

// Circular refund arrow with a ₹ inside — for the "return amount" money tile.
// (Deliberately NOT cilMoneyBack, which is the shared Refunds sidebar glyph.)
export const cilRupeeRefund = ['24 24', wrap(
  '<path d="M20.5 12a8.5 8.5 0 1 1-2.45-5.95"/>' +
  '<path d="M20.5 2.5V7h-4.5"/>' +
  '<path d="M15.6 7.8h-6.6h1.8a2.4 2.4 0 0 1 0 4.8h-1.8l3.6 3.6"/>' +
  '<path d="M9 10.2h6.6"/>'
)]

// KG unit marker for kilogram (kgs) tiles — the weight family is treated like the
// money family (a unit symbol, cf. cilRupee) rather than a drawn object, because
// object metaphors (kettlebell/weight/dumbbell) read as binoculars/bag/gym at tile
// size. Uses <text> (not wrap()) so the letters are FILLED, not hairline-outlined.
const KG_TEXT = 'text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-weight="700" fill="currentColor"'
export const cilWeight = ['24 24',
  `<text x="12" y="16.4" font-size="13" ${KG_TEXT}>KG</text>`
]

// Circular refund arrow with "KG" inside — "kgs returned" (mirrors cilRupeeRefund).
export const cilWeightReturn = ['24 24',
  '<g fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
  '<path d="M20.5 12a8.5 8.5 0 1 1-2.45-5.95"/>' +
  '<path d="M20.5 2.5V7h-4.5"/>' +
  '</g>' +
  `<text x="11.6" y="15.4" font-size="9" ${KG_TEXT}>KG</text>`
]

// Labeled box holding "KG" — the "bulk kgs" marker (a bulk quantity by weight).
export const cilWeights = ['24 24',
  '<g fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
  '<rect x="3.3" y="5" width="17.4" height="15" rx="2.5"/>' +
  '<path d="M3.3 9.3h17.4"/>' +
  '</g>' +
  `<text x="12" y="17.2" font-size="8" ${KG_TEXT}>KG</text>`
]

// Brand marks for the Care-of channels — official supplied logo paths, NOT run
// through wrap() (they have their own viewBox + paint style). Colour is set to
// currentColor so they still theme with the sidebar.
//
// Amazon: Font Awesome Free "amazon" (filled path, 640×640 viewBox).
export const cilAmazon = ['640 640',
  '<g transform="translate(-38.4,-38.4) scale(1.12)"><path fill="currentColor" d="M353.7 226.7C305 228.5 184.2 242.2 184.2 344.2C184.2 453.7 322.5 458.2 367.7 387.4C374.2 397.6 403.1 424.9 413 434.2L469.8 378.2C469.8 378.2 437.5 352.9 437.5 325.4L437.5 178.3C437.5 153 413 96 325.2 96C237.2 96 190.5 151 190.5 200.3L264 207.1C280.3 157.6 318.2 157.6 318.2 157.6C358.9 157.5 353.7 187.4 353.7 226.7zM353.7 313.5C353.7 393.5 269.5 381.5 269.5 330.7C269.5 283.5 320 274 353.7 272.9L353.7 313.5zM489.7 477C482 487 419.7 544 315.2 544C210.7 544 130.7 472.5 106.2 443C99.4 435.3 107.2 431.7 111.7 434.7C185 479.2 299.5 552.5 484.2 465C491.7 461.3 497.5 467 489.7 477zM529.5 479.2C523 495 513.5 506 508.3 510.2C502.8 514.7 498.8 512.9 501.8 506.4C504.8 499.9 521.1 459.9 514.5 451.4C508 443.1 477.5 447.1 466.5 448.2C455.7 449.2 453.5 450.2 452.5 447.9C450.2 442.2 474.2 432.4 490 430.4C505.7 428.6 531 429.6 536 436.1C539.7 441.2 536 463.2 529.5 479.2z"/></g>'
]

// Flipkart: SVG Repo "flipkart" (stroked outline, 192×192 viewBox, stroke-width 12).
export const cilFlipkart = ['192 192',
  '<g transform="translate(-7.68,-7.68) scale(1.08)"><path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="12" d="M156 30H36c-3.74 0-6 2.26-6 6v120c0 3.74 2.26 6 6 6h48l6.784-35.311h-9.732c-.346 0-35.009-1.636-35.009-1.636l26.015-2.219L77 120.349l-13.425-1.934 12.773-1.072-.841-3.048-20.871-3.17s22.676-2.531 23.022-2.531h16.465L95.8 99.56c1.961-10.968 6.414-19.052 13.391-25.066 7.011-6.054 15.91-9.04 26.722-9.04 4.364 0 7.147 1.025 8.355 3.142.801 1.263 1.364 3.502 1.894 5.83.502 2.39.95 4.555.644 6.13-.387 2.341-3.129 3.156-8.124 3.156h-1.717c-9.007 0-14.484 5.178-16.324 15.678l-1.649 9.197h10.452c3.896 0 5.301 2.729 4.222 8.864-1.154 6.387-3.658 9.231-7.541 9.231h-10.438L108 162h48c3.74 0 6-2.26 6-6V36c0-3.746-2.254-5.996-6-6Z"/></g>'
]
